export default __webpack_public_path__ + "static/media/wallet-product-referral.915ef84a.svg";